import { getDicList } from '@api/common';
import { COMMON_PLACEHOLDER, ROLE_KEYS_MAP } from '@constants';
import { userInfo } from '@store';
import { dicListAtom } from '@store/dicListStore';
import { recursiveIterateKeys } from '@utils/tool';
import {
  dealerSectorArr,
  salesSectorArr
} from '@views/pages/AnnouncementList/Announcement/CreateAnnouncement';
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

interface ResultInterface {
  data: any;
  [key: string]: any;
}

export function DicListHook(isReload: boolean = false) {
  const [dicList, setDicListState] = useRecoilState<any>(dicListAtom);
  const [userInfos] = useRecoilState(userInfo);

  const getList = async () => {
    const res: any = await getDicList({});
    const result = formatData(res?.dictList);
    const newState: any = res;
    setDicListState({
      data: newState?.dictList,
      ...result
    });
  };

  const getRoleSectorArr = () => {
    if (userInfos.roleKeys !== ROLE_KEYS_MAP.sales) {
      if (userInfos.roleKeys === ROLE_KEYS_MAP.dealer) {
        return dealerSectorArr;
      }
      return [];
    }

    const sectorIds = userInfos.userTypesId
      ? userInfos.userTypesId.split(',')
      : [];

    const hasSalesSector = sectorIds.some((sectorId: string) =>
      salesSectorArr.includes(sectorId)
    );
    const hasDealerSector = sectorIds.some((sectorId: string) =>
      dealerSectorArr.includes(sectorId)
    );

    if (hasSalesSector && hasDealerSector) {
      return [...salesSectorArr, ...dealerSectorArr];
    }

    if (hasSalesSector) {
      return salesSectorArr;
    }

    if (hasDealerSector) {
      return dealerSectorArr;
    }

    return [];
  };

  const formatRoleDicList = (data: any = {}) => {
    const roleSectorArr = getRoleSectorArr();

    if (!roleSectorArr.length || !data?.sector) {
      return data;
    }

    return {
      ...data,
      sector: data.sector.filter((item: any) =>
        roleSectorArr.includes(item.dictKey)
      )
    };
  };

  // 数据格式化
  const formatData = (data: any = []) => {
    const obj = data?.reduce((prev: any, cur: any) => {
      const { dictType, dictValue, children } = cur;
      prev[dictType] = prev[dictType] ? [...prev[dictType], cur] : [cur];

      // sector下拉联动数据处理
      if (dictType === 'sector' && children?.length > 0) {
        const sectorItem = formatData(
          recursiveIterateKeys(
            children,
            'dictKey',
            'dictValue',
            COMMON_PLACEHOLDER
          )
        );
        prev['sectorDict'] = prev['sectorDict']
          ? {
              ...prev['sectorDict'],
              [dictValue]: sectorItem
            }
          : {
              [dictValue]: sectorItem
            };
      }

      return prev;
    }, {});

    // 销售反馈信息中产品线
    if (obj.projectProductLine) {
      obj.projectProductLine = recursiveIterateKeys(
        obj?.projectProductLine,
        'dictKey',
        'dictValue',
        COMMON_PLACEHOLDER
      );
    }

    if (obj.projectProductLinePhaseTwo) {
      obj.projectProductLinePhaseTwo = recursiveIterateKeys(
        obj?.projectProductLinePhaseTwo,
        'dictKey',
        'dictValue',
        COMMON_PLACEHOLDER
      );
    }

    if (obj.noticeTwoUnCorrelatedReason) {
      obj.noticeTwoUnCorrelatedReason = recursiveIterateKeys(
        obj?.noticeTwoUnCorrelatedReason,
        'dictKey',
        'dictValue'
      );
    }

    if (obj.subjectOneUnCorrelatedReason) {
      obj.subjectOneUnCorrelatedReason = recursiveIterateKeys(
        obj?.subjectOneUnCorrelatedReason,
        'dictKey',
        'dictValue'
      );
    }

    if (obj.subjectTwoUnCorrelatedReason) {
      obj.subjectTwoUnCorrelatedReason = recursiveIterateKeys(
        obj?.subjectTwoUnCorrelatedReason,
        'dictKey',
        'dictValue'
      );
    }

    return obj;
  };

  const getStoreList = () => {
    if (dicList && !isReload) {
      return;
    }
    getList();
  };

  useEffect(() => {
    getStoreList();
  }, []);

  const result: ResultInterface = {
    ...formatRoleDicList(dicList)
  };

  return result;
}
